/* global axios */
import ApiClient from './ApiClient';

class CustomRole extends ApiClient {
  restoreDefault(id) {
    return axios.post(`${this.url}/${id}/restore_default`);
  }

  delete(id, replacementCustomRoleId) {
    return axios.delete(`${this.url}/${id}`, {
      data: replacementCustomRoleId
        ? { replacement_custom_role_id: replacementCustomRoleId }
        : {},
    });
  }

  constructor() {
    super('custom_roles', { accountScoped: true });
  }
}

export default new CustomRole();
